import {users} from '@cl/shared';
import {CLDispatch} from 'common/src/redux/store';
import {AgentName} from '../../../copilot.enums';
import assistantPlaintextChatItem from '../../../utils/creators/assistantPlaintextChatItem';
import {addChatItem} from '../../copilot.slice';

export default function addWelcomeMessage(
  dispatch: CLDispatch,
  chatId: string,
  agentName: AgentName,
) {
  const user = users.userSubject.data;
  const userFirstName = user?.firstName?.trim();
  const text = userFirstName
    ? `How can I help you today, ${userFirstName}?`
    : 'How can I help you today?';
  const chatItem = assistantPlaintextChatItem({agent: agentName, content: text});
  dispatch(addChatItem({chatId, chatItem}));
}
